export default __webpack_public_path__ + "static/media/mit-logo.84d6c1ee.png";